require('./transfersEmitedView.scss');

const PropTypes = require('prop-types');
// @vendor
const React = require('react');
const {
    Component
} = require('react');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');

// @commons
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { OKCover } = require('commonsComponents/OKCover');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @actions
const accountsActions = require('actions/getAccounts');
const emitedTransfersActions = require('actions/emitedTransfers');

// @components
const EmitedTransfers = require('components/transfers/emited/emitedTransfers/emitedTransfers');
const TransfersMoreOptionsButton = require('components/transfers/transfersMoreOptionsButton/transfersMoreOptionsButton');
const TransfersOptionsButton = require('components/transfers/transfersOptionsButton/transfersOptionsButton');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');

// @utilities
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname')

// @constants
const { GRAPHIC_TUTOR_TYPE_3 } = require('constants/index');
const { WEB_INACTIVE_ACCOUNT_ENABLED } = require('constants/flagBasedFeatures');

class TransfersEmitedView extends Component {
    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    componentDidMount() {
        this.props.requestAccounts();
    }

    componentWillUnmount() {
        const immEmitedTransfersFilters = this.props.immEmitedTransfers.get('filters');

        if (immEmitedTransfersFilters.getIn(['date', 'isActive']) ||
            immEmitedTransfersFilters.getIn(['amount', 'isActive']) ||
            immEmitedTransfersFilters.getIn(['currency', 'isActive'])) {
            this.props.clearFilters();
        }
    }

    render() {
        const {
            clearFilters,
            immAccounts,
            immEmitedTransfers,
            immFlagBasedFeatures,
            immScreen,
            match: { params: { accountId } },
            requestEmitedTransfers,
            requestEmitedTransfersNextPage,
            resetFilter,
            setFilters
        } = this.props;
        const immAccount = immAccounts.get('byId').get(accountId);
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-transfers'),
                url: '/myprofile/transfers'
            },
            {
                text: formatText('transfersLanding-emitedTranfers')
            }
        ];
        const tutorial = (
            <TutorialLauncher
                type={GRAPHIC_TUTOR_TYPE_3}
                title={formatText('tutorials-transfersEmitedsTitle')}
            />
        );
        let moreOptionsButton;
        let optionsButton;
        let content;

        if (immAccount) {
            moreOptionsButton = (<TransfersMoreOptionsButton immAccount={immAccount} />);
            optionsButton = (<TransfersOptionsButton immAccount={immAccount} />);
            content = (
                <EmitedTransfers
                    immAccount={immAccount}
                    immAccounts={immAccounts}
                    immEmitedTransfers={immEmitedTransfers}
                    immScreen={immScreen}
                    isInactiveAccountsEnabled={immFlagBasedFeatures.get(WEB_INACTIVE_ACCOUNT_ENABLED)}
                    requestEmitedTransfers={requestEmitedTransfers}
                    setFilters={setFilters}
                    resetFilter={resetFilter}
                    clearFilters={clearFilters}
                    requestEmitedTransfersNextPage={requestEmitedTransfersNextPage}
                />
            );
        } else {
            content = <LoadingSection />;
        }

        const transfersEmitedClassName = contactCenterClassName('transfers-emited-view')
        const transfersEmitedBodyClassName = contactCenterClassName('transfers-emited-view__body', 'grid-view__body')

        return (
            <div className={transfersEmitedClassName}>
                <div className="container-fluid">
                    <div className="row transfers-emited-view--header-identifier">
                        <OKCover size="medium" section="transfers" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                tutorial={tutorial}
                                finalTitle={getFinalTitle('transfersLanding-emitedTranfers')}>
                                {moreOptionsButton}
                                {optionsButton}
                            </OKHeaderSubPage>
                        </OKCover>
                    </div>
                </div>
                <div className={transfersEmitedBodyClassName}>
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            <div className="col-xs-12">
                                <OKSectionBox>
                                    {content}
                                </OKSectionBox>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

TransfersEmitedView.propTypes = {
    clearFilters: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immEmitedTransfers: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immScreen: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    requestAccounts: PropTypes.func.isRequired,
    requestEmitedTransfers: PropTypes.func.isRequired,
    requestEmitedTransfersNextPage: PropTypes.func.isRequired,
    resetFilter: PropTypes.func.isRequired,
    setFilters: PropTypes.func.isRequired,
};

module.exports.constructor = TransfersEmitedView;
module.exports.TransfersEmitedView = connect(
    state => ({
        immAccounts: state.accounts,
        immEmitedTransfers: state.emitedTransfers,
        immScreen: state.screen,
        immFlagBasedFeatures: state.flagBasedFeatures,
    }),
    {
        clearFilters: emitedTransfersActions.clearEmitedTransfersFilters,
        requestAccounts: accountsActions.requestAccounts,
        requestEmitedTransfers: emitedTransfersActions.requestEmitedTransfers,
        requestEmitedTransfersNextPage: emitedTransfersActions.requestEmitedTransfersNextPage,
        resetFilter: emitedTransfersActions.resetEmitedTransfersFilter,
        setFilters: emitedTransfersActions.setEmitedTransfersFilters,
    }
)(TransfersEmitedView);
